import React, { useState, useEffect, useRef } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import NavBar from "../nav/nav-bar";
import ReportNav from "./report-nav";
import { useLocation, useHistory } from "react-router-dom";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Service from "../webservice/http";
import ClipLoader from "react-spinners/ClipLoader";
import { makeVisible } from "../features/my-report";
import { useDispatch } from "react-redux";
function Myreportdetail() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const inputRef = useRef(null);
  const service = new Service();

  const reportData = location.state?.reportData || [];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reportName, setReportName] = useState(
    `My report ${Math.trunc(Math.random() * 10) + 1} `
  );
  const [Loading, setLoading] = useState(false);
  const dates = reportData.map((item) => item.date);
  const callCounts = reportData.map((item) => item.count);
  // console.log(reportData);

  const reportBarChart = {
    chart: {
      type: "column",
      height: "450px",
    },
    title: {
      text: "Call Report",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: dates,
      title: {
        text: "Dates",
      },
    },
    yAxis: {
      title: {
        text: "Call Count",
      },
      tickInterval: 1,
    },
    plotOptions: {
      column: {
        borderRadius: 5,
      },
    },
    series: [
      {
        data: callCounts,
        name: "Call Count",
        color: "#7cb5ec",
      },
    ],
  };

  const handleCreateReport = async () => {
    setLoading(true);
    try {
      const payload = {
        report_name: reportName,
        data: reportData,
      };

      const response = await service.post(
        "api/call_verification/save_report/",
        payload
      );

      closeModal();
      setLoading(false);
      history.push("/reports/my-reports");
    } catch (error) {
      console.error("Error saving report:", error.message);
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.select();
      }
    }, 0);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleNameChange = (e) => {
    setReportName(e.target.value);
  };

  return (
    <div>
      <Header />
      <NavBar />
      {Loading && (
        <div
          className="flex justify-center items-center"
          style={{ height: "100vh" }}
        >
          {" "}
          <ClipLoader color="#2056FF" size="50px" />
        </div>
      )}
      <div className="container-fluid" style={{ background: "#EEF2F5" }}>
        <div className="my-call bg-white">
          <div
            className="side-panel-with-table clearfix flex"
            style={{ display: "flex" }}
          >
            <ReportNav />
            <div className="call-table" style={{ marginBottom: "80px" }}>
              <div
                className="my-calls-column"
                style={{ padding: "15px 0px 0px 15px" }}
              >
                <div className="calls-top-pannel">
                  <div className="row">
                    <div className="flex justify-between items-center px-6">
                      <div className="pannel-heading clearfix flex items-center">
                        <div className="pannel-heading-icon">
                          <i
                            className="fa fa-file-text-o"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <div className="pannel-heading-info">
                          <h3>My Reports</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div
                  className="dropdowns-container"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "10px",
                  }}
                >
                  <div
                    className="grid grid-cols-1 mt-8 px-4 role"
                    style={{
                      height: "500px",
                      width: "100%",
                    }}
                  >
                    {reportData.length > 0 ? (
                      <div>
                        {/* Render the chart */}
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={reportBarChart}
                        />
                      </div>
                    ) : (
                      <div
                        className="flex justify-center items-center text-gray-500"
                        style={{ height: "100%" }}
                      >
                        <h3>No calls found</h3>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <div className="flex justify-end mt-4 gap-4">
                    <button
                      onClick={openModal}
                      className="px-5 py-3 rounded-lg font-semibold hover:text-white text-gray-700 bg-white run-my-report hover:border-0 hover:ease-in-out"
                    >
                      Save As
                    </button>
                    <button
                      onClick={() => {
                        dispatch(makeVisible()); // Reset the state
                        history.push("/reports/my-reports");
                      }}
                      className="px-5 py-3 rounded-lg font-semibold hover:text-white text-gray-700 bg-white my-report-cancel hover:border-0 hover:ease-in-out"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className="bg-white rounded-lg shadow-lg p-6 relative"
            style={{ width: "350px", height: "180px" }}
          >
            <h4 className="font-semibold mb-4">Save As</h4>
            <div className="mb-4">
              <label className="block text-2xl font-medium text-gray-700">
                Name:
              </label>
              <input
                type="text"
                value={reportName}
                onChange={handleNameChange}
                className="mt-4 block  w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 "
                style={{ height: "30px", backgroundColor: "white" }}
                ref={inputRef}
              />
            </div>

            <div className="flex gap-4 bottom-6 absolute right-4">
              <button
                onClick={closeModal}
                className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleCreateReport}
                className="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}

export default Myreportdetail;
